import React from 'react';
import { useLocation } from 'react-router-dom';
import Questionnaires from '../components/business/Questionnaires';
import QuestionnaireDetails from '../components/business/questionnaires/QuestionnaireDetails';

export const QuestionnairesCtx = React.createContext({});

function QuestionnairesPageProvider(props) {
  const ctx = {
  };
  return (
    <QuestionnairesCtx.Provider value={ ctx }>
      {props.children}
    </QuestionnairesCtx.Provider>
  );
}

function QuestionnairesPage() {
  const location = useLocation();
  const { search } = location;
  const params = new URLSearchParams(search);
  const id = params.get('id');

  if (null != id) {
    return <QuestionnaireDetails id={ id } />;
  }

  return (
    <QuestionnairesPageProvider>
      <Questionnaires />
    </QuestionnairesPageProvider>
  );
}

export default QuestionnairesPage;
